import { render } from "./index.vue?vue&type=template&id=451c759b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=451c759b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451c759b"]])

export default __exports__